import { FC, useContext, useMemo } from 'react';

import {
  AlienIcon,
  BonusAddIcon,
  BonusRemoveIcon,
  PercentIcon,
  ChartAverageDownIcon,
  ChartAverageTopIcon,
} from '@smartshell/ui-kit';

import { ReportSummaryBlock } from 'components';
import { LocalizationContext } from 'localization';
import { SettingsContext } from 'settings';

import { formatMoney, useSummaryValues } from '../utils';
import s from './BonusSummary.module.scss';
import { IBonusSummaryProps } from './interfaces';

export const BonusSummary: FC<IBonusSummaryProps> = ({ data, loading }) => {
  const { t } = useContext(LocalizationContext);
  const { currency } = useContext(SettingsContext).state.settings;

  const { getValue } = useSummaryValues(data, loading);

  const normalizeData = useMemo(() => {
    return [
      {
        text: t('accrued'),
        value: `${formatMoney(getValue('Всего начислено'))}`,
        icon: <BonusAddIcon color="link-info" />,
        color: 'blue',
      },
      {
        text: t('waste'),
        value: `${formatMoney(getValue('Всего потрачено'))}`,
        icon: <BonusRemoveIcon color="warning" />,
        color: 'orange',
      },
      {
        text: t('report.bonus.summary.used'),
        value: `${formatMoney(getValue('Уникальных пользователей'))}`,
        percent: !loading
          ? `${getValue('Процент пользователей с бонусами')}${data ? '%' : ''}`
          : '—',
        icon: <AlienIcon color="primary" />,
      },
      {
        text: t('report.bonus.summary.average'),
        value: `${formatMoney(getValue('Средний депозит на пользователя'))}`,
        icon: <ChartAverageDownIcon color="link-info" />,
        color: 'blue',
      },
      {
        text: t('report.bonus.summary.waste'),
        value: `${formatMoney(getValue('Средний расход на пользователя'))}`,
        icon: <ChartAverageTopIcon color="warning" />,
        color: 'orange',
      },
      {
        text: t('report.bonus.summary.revenue'),
        value: `${getValue('Процент суммы платежей с бонусами')}${
          data ? '%' : ''
        }`,
        icon: <PercentIcon color="primary" />,
      },
    ];
  }, [t, currency.sign, getValue]);

  return (
    <div className={s.container}>
      {normalizeData.map((item) => (
        <ReportSummaryBlock
          className={s.summary}
          key={`${item.text}-${item.value}`}
          item={item}
        />
      ))}
    </div>
  );
};
